import React from "react";
import { DataSection } from "../components";

const fields = [
  { key: "title", label: "Feststellung", type: "text" },
  { key: "description", label: "Beschreibung", type: "textarea", table: false },
  { key: "severity", label: "Schweregrad", type: "select", options: ["low", "medium", "high"], badge: true },
  { key: "status", label: "Status", type: "select", options: ["open", "in_progress", "closed"], badge: true },
  { key: "owner", label: "Verantwortlich", type: "text" },
  { key: "due_date", label: "Frist", type: "date" },
];

const Findings = () => <DataSection overline="Audit" title="Audit-Feststellungen" entity="findings" fields={fields} />;
export default Findings;
